<div class="dash-records-modal-wrapper">

  <!-- Cabecera Glassmorphism Anti-Notch -->
  <div class="dash-records-header">
    <div class="header-main-row">
      <button type="button" class="modal-close-btn" (click)="dismiss()">
        <ion-icon name="close-outline"></ion-icon>
      </button>

      <div class="title-group">
        <h2 class="title-main">{{ titulo }}</h2>
        <span class="title-sub">{{ subtitulo || (filteredRecords.length + ' registros pendientes') }}</span>
      </div>

      <!-- Conmutador Lista / Tarjeta (Estilo InspeccionesPage) -->
      <div class="view-mode-toggle-pill" *ngIf="filteredRecords.length > 0">
        <button type="button" class="toggle-mode-btn" [class.active]="viewMode === 'list'" (click)="setViewMode('list')" title="Vista Lista">
          <ion-icon name="reorder-four-outline"></ion-icon>
        </button>
        <button type="button" class="toggle-mode-btn" [class.active]="viewMode === 'card'" (click)="setViewMode('card')" title="Vista Tarjeta">
          <ion-icon name="albums-outline"></ion-icon>
        </button>
      </div>
    </div>

    <!-- Buscador Integrado -->
    <div class="modal-search-wrapper" *ngIf="records.length > 3">
      <ion-searchbar 
        [(ngModel)]="searchText"
        placeholder="Buscar por cliente, tienda, id..."
        [debounce]="200"
        class="clean-searchbar">
      </ion-searchbar>
    </div>
  </div>

  <!-- Contenido Scroll de Tarjetas o Baraja -->
  <ion-content class="modal-body-content">

    <!-- ════════════ VISTA 1: LISTA VERTICAL ════════════ -->
    <div class="records-container" *ngIf="viewMode === 'list'">

      <!-- Conteo y Resumen de Estado -->
      <div class="records-summary-strip">
        <span class="summary-badge">
          <ion-icon name="layers-outline"></ion-icon>
          Total: {{ filteredRecords.length }}
        </span>
        <span class="hint-text">Toca un registro o el botón para resolver</span>
      </div>

      <!-- Tarjetas de Registros en Lista -->
      <div class="record-card" *ngFor="let item of filteredRecords" (click)="ejecutarAccion(item)">
        
        <div class="card-top-row">
          <div class="badge-id">#{{ item.id }}</div>
          <span class="badge-state" *ngIf="item.estado">{{ item.estado }}</span>
        </div>

        <div class="card-main-info">
          <h4 class="record-client">{{ item.cliente || 'Sin Cliente' }}</h4>
          
          <!-- Si hay campos de detalle configurados para esta métrica -->
          <ng-container *ngIf="camposDetalle && camposDetalle.length > 0">
            <div 
              class="record-meta-line" 
              *ngFor="let c of camposDetalle"
              [ngClass]="c.color ? 'text-' + c.color : ''">
              <ion-icon [name]="c.icono || 'information-circle-outline'"></ion-icon>
              <span>
                <strong *ngIf="c.label">{{ c.label }}: </strong>
                {{ getValorCampo(item, c) }}
              </span>
            </div>
          </ng-container>

          <!-- Fallback estándar si no hay campos_detalle específicos -->
          <ng-container *ngIf="!camposDetalle || camposDetalle.length === 0">
            <div class="record-meta-line" *ngIf="item.lugar">
              <ion-icon name="location-outline"></ion-icon>
              <span>{{ item.lugar }}</span>
            </div>

            <div class="record-meta-line" *ngIf="item.solicitante">
              <ion-icon name="person-outline"></ion-icon>
              <span>{{ item.solicitante }}</span>
            </div>
          </ng-container>

          <p class="record-desc" *ngIf="item.descripcion || item.dt8">
            {{ item.descripcion || item.dt8 }}
          </p>
        </div>

        <!-- Botones de Acción: Configurables o Fallback -->
        <div class="card-action-footer">
          <ng-container *ngIf="accionesModal && accionesModal.length > 0">
            <ng-container *ngFor="let acc of accionesModal">
              <button 
                type="button" 
                *ngIf="debeMostrarAccion(acc, item)"
                class="btn-dynamic-action"
                [ngClass]="[
                  acc.tipo === 'accion_directa' && acc.handler === 'marcar_ars' ? 'btn-action-ars' : '',
                  acc.tipo === 'accion_directa' && acc.handler === 'finalizar' ? 'btn-action-finalizar' : '',
                  acc.tipo !== 'accion_directa' ? ('btn-action-primary theme-' + (acc.color || color || 'blue')) : ''
                ]"
                (click)="ejecutarBotonConfigurado(acc, item, $event)">
                <ion-icon [name]="acc.icono || 'chevron-forward-outline'"></ion-icon>
                <span>{{ acc.label || 'Ejecutar' }}</span>
              </button>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="!accionesModal || accionesModal.length === 0">
            <button 
              type="button" 
              class="btn-action-ars" 
              *ngIf="isArsClient(item) && (!item.firmado || item.firmado === false || item.dt9 === 'N')" 
              (click)="confirmarMarcarArs(item, $event)">
              <ion-icon name="document-text-outline"></ion-icon>
              <span>Ya firmé el reporte</span>
            </button>

            <!-- Finalizar: si no requiere ARS visible para todos; si requiere ARS solo para admin cuando ya esté firmado -->
            <button 
              type="button" 
              class="btn-action-finalizar" 
              *ngIf="!isArsClient(item) || (isAdminUser && (item.firmado === true || item.firmado === 'Y' || item.dt9 === 'Y'))" 
              (click)="confirmarFinalizarTrabajo(item, $event)">
              <ion-icon name="checkmark-circle-outline"></ion-icon>
              <span>Ya Finalicé este trabajo</span>
            </button>

            <button type="button" class="btn-action-primary" [ngClass]="'theme-' + (color || 'blue')" (click)="ejecutarAccion(item, $event)">
              <ion-icon [name]="accionResolucion === 'galeria' ? 'images-outline' : 'open-outline'"></ion-icon>
              <span>{{ accionResolucion === 'galeria' ? 'Cargar Imágenes' : 'Abrir Trabajo' }}</span>
            </button>
          </ng-container>
        </div>

      </div>

      <!-- Estado Vacío -->
      <div class="empty-state" *ngIf="filteredRecords.length === 0">
        <ion-icon name="checkmark-done-circle-outline"></ion-icon>
        <h4>Todo al día</h4>
        <p>No se encontraron registros pendientes con esta condición.</p>
      </div>

    </div>

    <!-- ════════════ VISTA 2: BARAJA DE TARJETA GLASSMORPHISM (COMO INSPECCIONESPAGE) ════════════ -->
    <div class="dash-wallet-view" *ngIf="viewMode === 'card'">

      <!-- Estado Vacío -->
      <div class="empty-state" *ngIf="filteredRecords.length === 0">
        <ion-icon name="checkmark-done-circle-outline"></ion-icon>
        <h4>Todo al día</h4>
        <p>No se encontraron registros pendientes con esta condición.</p>
      </div>

      <!-- Contenedor Baraja Wallet -->
      <div class="pg-wallet-stack" *ngIf="currentCard"
        (touchstart)="onCardTouchStart($event)"
        (touchend)="onCardTouchEnd($event)">

        <!-- Pestañas apiladas superiores con efecto de profundidad -->
        <div class="pg-stacked-tabs" *ngIf="stackedCardTabs.length > 0">
          <div *ngFor="let tab of stackedCardTabs; let i = index" 
            class="pg-stacked-tab-card"
            [ngClass]="'pg-tab-depth-' + (stackedCardTabs.length - 1 - i)"
            [style.z-index]="i + 1"
            (click)="selectCard(tab.originalIndex)">
            <div class="tab-content">
              <span class="tab-client-name">#{{ tab.card.id }} — {{ tab.card.cliente || 'Sin Cliente' }} · {{ tab.card.lugar || 'Sin Ubicación' }}</span>
              <span class="tab-badge" *ngIf="tab.card.estado">{{ tab.card.estado }}</span>
            </div>
          </div>
        </div>

        <!-- Tarjeta Principal Activa Glassmorphic -->
        <div class="pg-active-quote-card">

          <!-- Header de la Tarjeta Glass -->
          <div class="quote-glass-header">
            <div class="quote-glass-nav-row">
              <div class="quote-glass-folio">
                <span class="quote-folio-pill">#{{ currentCard.id }}</span>
                <span class="quote-status-glass-pill" *ngIf="currentCard.estado">
                  <ion-icon name="ellipse"></ion-icon>
                  <span>{{ currentCard.estado }}</span>
                </span>
              </div>

              <!-- Paginador Anterior / Siguiente -->
              <div class="quote-glass-nav" (click)="$event.stopPropagation()">
                <span class="quote-counter-tag">{{ currentCardIndex + 1 }} / {{ filteredRecords.length }}</span>
                <button type="button" class="pg-wc-arrow-btn" (click)="prevCard()" [disabled]="filteredRecords.length <= 1" title="Anterior">
                  <ion-icon name="chevron-back-outline"></ion-icon>
                </button>
                <button type="button" class="pg-wc-arrow-btn" (click)="nextCard()" [disabled]="filteredRecords.length <= 1" title="Siguiente">
                  <ion-icon name="chevron-forward-outline"></ion-icon>
                </button>
              </div>
            </div>
          </div>

          <!-- Divisor Glass -->
          <div class="pg-wc-divider"></div>

          <!-- Cuerpo Glassmorphic de la Tarjeta -->
          <div class="quote-glass-body">
            
            <div class="quote-glass-summary-card">
              <!-- Cliente -->
              <div class="summary-client-row">
                <div class="summary-sub-icon">
                  <ion-icon name="business"></ion-icon>
                </div>
                <div class="summary-client-text">
                  <span class="summary-item-lbl">Cliente</span>
                  <span class="summary-client-name">{{ currentCard.cliente || 'Sin Cliente' }}</span>
                </div>
              </div>

              <!-- Lugar / Ubicación Hero -->
              <div class="summary-hero-row" *ngIf="currentCard.lugar">
                <div class="summary-icon-wrap">
                  <ion-icon name="location-outline"></ion-icon>
                </div>
                <div class="summary-hero-text">
                  <span class="summary-tag">Ubicación / Tienda</span>
                  <h3 class="summary-main-title">{{ currentCard.lugar }}</h3>
                </div>
              </div>

              <!-- Descripción del Trabajo (después de ubicación / tienda) -->
              <p class="record-desc-glass" *ngIf="currentCard.descripcion || currentCard.dt8">
                {{ currentCard.descripcion || currentCard.dt8 }}
              </p>

              <!-- Chip Destacado a Todo lo Largo: Tiempo Activo -->
              <div class="glass-chip-fullwidth border-danger" *ngIf="chipTiempoActivo">
                <div class="chip-icon">
                  <ion-icon [name]="chipTiempoActivo.icono || 'time-outline'"></ion-icon>
                </div>
                <div class="chip-info">
                  <span class="chip-lbl">{{ chipTiempoActivo.label || 'Tiempo Activo' }}</span>
                  <span class="chip-val">{{ getValorCampo(currentCard, chipTiempoActivo) }}</span>
                </div>
              </div>

              <div class="summary-card-divider" *ngIf="camposDetalleCard && camposDetalleCard.length > 0"></div>

              <!-- Lista de Campos de Detalle Dinámicos en Tarjeta (debajo del tiempo activo, en cuadrícula estándar) -->
              <div class="glass-detail-chips-grid" *ngIf="camposDetalleCard && camposDetalleCard.length > 0">
                <div class="glass-chip-box" *ngFor="let c of camposDetalleCard" [ngClass]="c.color ? 'border-' + c.color : ''">
                  <div class="chip-icon">
                    <ion-icon [name]="c.icono || 'information-circle-outline'"></ion-icon>
                  </div>
                  <div class="chip-info">
                    <span class="chip-lbl">{{ c.label || c.campo }}</span>
                    <span class="chip-val">{{ getValorCampo(currentCard, c) }}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- Footer con Acciones Directas en Tarjeta Glass -->
          <div class="card-glass-actions-footer" (click)="$event.stopPropagation()">
            <ng-container *ngIf="accionesModal && accionesModal.length > 0">
              <ng-container *ngFor="let acc of accionesModal">
                <button 
                  type="button" 
                  *ngIf="debeMostrarAccion(acc, currentCard)"
                  class="btn-glass-action"
                  [ngClass]="[
                    acc.tipo === 'accion_directa' && acc.handler === 'marcar_ars' ? 'btn-glass-ars' : '',
                    acc.tipo === 'accion_directa' && acc.handler === 'finalizar' ? 'btn-glass-finalizar' : '',
                    acc.tipo !== 'accion_directa' ? ('btn-glass-primary theme-' + (acc.color || color || 'blue')) : ''
                  ]"
                  (click)="ejecutarBotonConfigurado(acc, currentCard, $event)">
                  <ion-icon [name]="acc.icono || 'chevron-forward-outline'"></ion-icon>
                  <span>{{ acc.label || 'Ejecutar' }}</span>
                </button>
              </ng-container>
            </ng-container>

            <!-- Fallback estándar -->
            <ng-container *ngIf="!accionesModal || accionesModal.length === 0">
              <button 
                type="button" 
                class="btn-glass-action btn-glass-ars" 
                *ngIf="isArsClient(currentCard) && (!currentCard.firmado || currentCard.firmado === false || currentCard.dt9 === 'N')" 
                (click)="confirmarMarcarArs(currentCard, $event)">
                <ion-icon name="document-text-outline"></ion-icon>
                <span>Ya firmé el reporte</span>
              </button>

              <!-- Finalizar: si no requiere ARS visible para todos; si requiere ARS solo para admin cuando ya esté firmado -->
              <button 
                type="button" 
                class="btn-glass-action btn-glass-finalizar" 
                *ngIf="!isArsClient(currentCard) || (isAdminUser && (currentCard.firmado === true || currentCard.firmado === 'Y' || currentCard.dt9 === 'Y'))" 
                (click)="confirmarFinalizarTrabajo(currentCard, $event)">
                <ion-icon name="checkmark-circle-outline"></ion-icon>
                <span>Ya Finalicé este trabajo</span>
              </button>

              <button type="button" class="btn-glass-action btn-glass-primary" (click)="ejecutarAccion(currentCard, $event)">
                <ion-icon [name]="accionResolucion === 'galeria' ? 'images-outline' : 'open-outline'"></ion-icon>
                <span>{{ accionResolucion === 'galeria' ? 'Cargar Imágenes' : 'Abrir Trabajo' }}</span>
              </button>
            </ng-container>
          </div>

        </div>

      </div>

    </div>

  </ion-content>

</div>
